<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="series" role="doc-chapter">
<p class="sert"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><img alt="" height="100" src="images/logo-chicago-guides.jpg" width="147"/></p>
<p class="ser"><i>Writing for Social Scientists</i></p>
<p class="serau">Howard S. Becker</p>
<p class="ser"><i>Writing Your Journal Article in Twelve Weeks</i></p>
<p class="serau">Wendy Laura Belcher</p>
<p class="ser"><i>Writing Fiction</i></p>
<p class="serau">Janet Burroway, with Elizabeth Stuckey-French and Ned Stuckey-French</p>
<p class="ser"><i>Writing Abroad</i></p>
<p class="serau">Peter Chilson and Joanne B. Mulcahy</p>
<p class="ser"><i>The Architecture of Story</i></p>
<p class="serau">Will Dunne</p>
<p class="ser"><i>The Business of Being a Writer</i></p>
<p class="serau">Jane Friedman</p>
<p class="ser"><i>From Dissertation to Book</i></p>
<p class="serau">William Germano</p>
<p class="ser"><i>Getting It Published</i></p>
<p class="serau">William Germano</p>
<p class="ser"><i>From Notes to Narrative</i></p>
<p class="serau">Kristen Ghodsee</p>
<p class="ser"><i>Storycraft</i></p>
<p class="serau">Jack Hart</p>
<p class="ser"><i>Thinking Like a Political Scientist</i></p>
<p class="serau">Christopher Howard</p>
<p class="ser"><i>Write No Matter What</i></p>
<p class="serau">Joli Jensen</p>
<p class="ser"><i>Economical Writing</i></p>
<p class="serau">Deirdre Nansen McCloskey</p>
<p class="ser"><i>Developmental Editing</i></p>
<p class="serau">Scott Norton</p>
<p class="ser"><i>The Writer’s Diet</i></p>
<p class="serau">Helen Sword</p>
<p class="ser"><i>Write Your Way In</i></p>
<p class="serau">Rachel Toor</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-germano-0003.vue?2d4b9b7a